import { ItemProps } from 'interface/menu/menuInfo';
import { memo } from 'react';
import { Box, List, Typography } from '@mui/material';
import useMenu from 'hooks/useMenu';
import MenuItem from './MenuItem';
import MenuCollapse from './MenuCollapse';

interface IMenuGroupProps {
  item: ItemProps;
}
function MenuGroup({ item }: IMenuGroupProps): JSX.Element {
  const { open } = useMenu();
  const childrenList = item.children?.map(menuItem => {
    switch (menuItem.type) {
      case 'collapse':
        return <MenuCollapse key={menuItem.id} item={menuItem} level={1} />;
      case 'item':
        return <MenuItem key={menuItem.id} item={menuItem} level={1} />;
      default:
        return null;
    }
  });
  return (
    <List
      subheader={
        item.title &&
        open && (
          <Box sx={{ pl: 3, mb: 1 }}>
            <Typography variant="subtitle1" color="textSecondary">
              {item.title}
            </Typography>
          </Box>
        )
      }
      sx={{ mb: 0, py: '0.25rem', zIndex: 0 }}
    >
      {childrenList}
    </List>
  );
}

export default memo(MenuGroup);
